import { useTranslation } from 'react-i18next'

import { useAsyncCallback } from '../../../../../hooks'
import { ConfirmationModal } from '../../../../Confirmation'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY } from '../../RequestProfileActionsWidget.constants'

export function useRequestProfileArchiveActions() {
  const { t } = useTranslation()

  const { handleCloseModal, handleUpdateEntity, setModal } =
    useRequestProfileContext()

  const handleSubmitArchive = useAsyncCallback(() => {
    return handleUpdateEntity(
      { archived: { value: true } },
      REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY.archive
    ).then(handleCloseModal)
  }, [handleCloseModal, handleUpdateEntity])

  const handleSubmitRestore = useAsyncCallback(() => {
    return handleUpdateEntity(
      { archived: { value: false } },
      REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY.restore
    ).then(handleCloseModal)
  }, [handleCloseModal, handleUpdateEntity])

  function handleClickArchive() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t('RequestProfile.ArchiveModalSubmitBtnKey'),
        }}
        description={t('RequestProfile.ArchiveModalDescriptionKey')}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitArchive}
      />
    )
  }

  function handleClickRestore() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t('RequestProfile.RestoreModalSubmitBtnKey'),
        }}
        description={t('RequestProfile.RestoreModalDescriptionKey')}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitRestore}
      />
    )
  }

  return { handleClickArchive, handleClickRestore }
}
